import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import TheaterComedyRoundedIcon from '@mui/icons-material/TheaterComedyRounded';
import CameraAltRoundedIcon from '@mui/icons-material/CameraAltRounded';
import EventNoteRoundedIcon from '@mui/icons-material/EventNoteRounded';
import BrushRoundedIcon from '@mui/icons-material/BrushRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

export default function AppHomePage({
  t = {}, onCreateStory, onStartPhotoStory, onStartVisualSchedule,
  onStartScenario, onStartDrawing,
}) {
  const text = {
    eyebrow: t.app_home_eyebrow || 'MARSTRIX',
    title: t.app_home_title || 'What kind of support would help today?',
    understand: t.app_home_understand || 'Understand',
    understandBody: t.app_home_understand_body || 'Make everyday situations easier to understand.',
    practise: t.app_home_practise || 'Practise',
    practiseBody: t.app_home_practise_body || 'Practise everyday situations safely.',
    express: t.app_home_express || 'Express',
    expressBody: t.app_home_express_body || 'Share experiences and ideas creatively.',
    socialStory: t.sb_social_story || 'Social Story',
    photoStory: t.sb_photo_story || 'Photo Story',
    visualSchedule: t.sb_visual_schedule || 'Visual Schedule',
    scenarioPractice: t.scenario_practice || 'Scenario Practice',
    talkAndDraw: t.sb_creative_drawing || 'Talk & Draw',
  };

  const cardSx = { flex: 1, minWidth: 0, p: { xs: 3, md: 3.5 }, borderRadius: 4, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' };
  const activityButtonSx = { width: '100%', justifyContent: 'space-between', bgcolor: 'rgba(255,255,255,.58)', borderColor: 'rgba(39,77,59,.18)', color: '#1F352A', '&:hover': { bgcolor: 'rgba(255,255,255,.9)', borderColor: 'rgba(39,77,59,.32)' } };
  return (
    <Box sx={{ width: '100%', maxWidth: 1180, mx: 'auto', pt: { xs: 10, sm: 11 }, px: 2, pb: 5 }}>
      <Typography sx={{ color: '#6F9654', fontSize: 12, fontWeight: 900, letterSpacing: '.16em' }}>{text.eyebrow}</Typography>
      <Typography component="h1" sx={{ mt: 1, mb: 4, color: '#1F352A', fontSize: { xs: 34, md: 46 }, fontWeight: 900, letterSpacing: '-.035em' }}>{text.title}</Typography>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 2.5 }}>
        <Box sx={{ ...cardSx, bgcolor: '#E6EED1' }}>
          <AutoStoriesRoundedIcon sx={{ color: '#3A6752', fontSize: 40 }} />
          <Typography variant="h5" sx={{ mt: 2.5, fontWeight: 900 }}>{text.understand}</Typography>
          <Typography sx={{ mt: 1.25, mb: 3, color: '#52635A', lineHeight: 1.7 }}>{text.understandBody}</Typography>
          <Box sx={{ mt: 'auto', width: '100%', display: 'grid', gap: 1 }}>
            <Button variant="outlined" startIcon={<AutoStoriesRoundedIcon />} endIcon={<ArrowForwardRoundedIcon />} onClick={onCreateStory} sx={activityButtonSx}>{text.socialStory}</Button>
            <Button variant="outlined" startIcon={<EventNoteRoundedIcon />} endIcon={<ArrowForwardRoundedIcon />} onClick={onStartVisualSchedule} sx={activityButtonSx}>{text.visualSchedule}</Button>
          </Box>
        </Box>
        <Box sx={{ ...cardSx, bgcolor: '#F8E7D7' }}>
          <TheaterComedyRoundedIcon sx={{ color: '#9A5D3E', fontSize: 40 }} />
          <Typography variant="h5" sx={{ mt: 2.5, fontWeight: 900 }}>{text.practise}</Typography>
          <Typography sx={{ mt: 1.25, mb: 3, color: '#665B54', lineHeight: 1.7 }}>{text.practiseBody}</Typography>
          <Box sx={{ mt: 'auto', width: '100%' }}>
            <Button variant="outlined" startIcon={<TheaterComedyRoundedIcon />} endIcon={<ArrowForwardRoundedIcon />} onClick={onStartScenario} sx={activityButtonSx}>{text.scenarioPractice}</Button>
          </Box>
        </Box>
        <Box sx={{ ...cardSx, bgcolor: '#E8EEF7' }}>
          <ChatBubbleOutlineRoundedIcon sx={{ color: '#9A5D3E', fontSize: 40 }} />
          <Typography variant="h5" sx={{ mt: 2.5, fontWeight: 900 }}>{text.express}</Typography>
          <Typography sx={{ mt: 1.25, mb: 3, color: '#52606D', lineHeight: 1.7 }}>{text.expressBody}</Typography>
          <Box sx={{ mt: 'auto', width: '100%', display: 'grid', gap: 1 }}>
            <Button variant="outlined" startIcon={<CameraAltRoundedIcon />} endIcon={<ArrowForwardRoundedIcon />} onClick={onStartPhotoStory} sx={activityButtonSx}>{text.photoStory}</Button>
            <Button variant="outlined" startIcon={<BrushRoundedIcon />} endIcon={<ArrowForwardRoundedIcon />} onClick={onStartDrawing} sx={activityButtonSx}>{text.talkAndDraw}</Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
